/*
 * File: SelectMedium.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 20, 2025 at 11:54 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: April 30, 2025 at 1:34 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { LegalSnippet as LegalSnippetBase } from '../../LegalSnippet';
import { Card } from '../../Card';

// Constants
import {
	mediumBreakpoint, ShareBottomPadding, ShareTopbarHeight
} from '../../../styles/constants';


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	min-height: calc(100vh - ${ShareTopbarHeight}px - ${ShareBottomPadding}px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const InnerStep = styled.div`
	width: 100%;
	max-width: 700px;
	padding: 50px 0px 50px;
`;

export const ContentContainer = styled.div`
	p {
		margin: 10px 0px 0px;
	}
	br {
		margin: 10px;
	}
`;

export const ActionContainer = styled.div`
	margin: 30px 0px 0px;
	display: flex;
	gap: 10px;
`;

export const LegalSnippet = styled(LegalSnippetBase)`
	margin: 30px 0px 0px;
`;

export const MediumOptions = styled.div`
	display: flex;
	gap: 20px;
	margin: 35px 0px 40px;
	flex-direction: column;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		flex-direction: row;
		gap: 30px;
	}
`;

export const MediumOption = styled.div`
	cursor: pointer;
	flex: 1 1 0;
	width: 0;
	width: 100%;

	&:hover {
		transform: scale(1.02);
	}
`;

export const OptionCard = styled(Card)`
	padding: 25px;
	position: relative;
	overflow: hidden;

	p {
		margin: 8px 0px 0px;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const ActiveIndicator = styled.div`
	width: 100%;
	height: 8px;
	background-color: ${({ theme }) => theme.primaryDecoration};
	position: absolute;
	top: 0px;
	left: 0px;
	opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
`;

export const Illustration = styled.img`
	width: 90px;
	height: 90px;
	margin: 0px 0px 10px;
`;
